<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('addheader')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-row>
                        <v-col cols="12"
                               sm="6"
                               md="4">
                            <v-text-field :label="$t('name')"
                                          v-model="header.name" dense outlined
                                          required></v-text-field>
                        </v-col>

                        <v-col cols="12"
                               sm="6"
                               md="4">
                            <v-autocomplete :items="types"
                                            :label="$t('headerlevel')"
                                            v-model="header.type"
                                            item-value="value" dense outlined
                                            item-text="id"
                                            @input="changeDDL"></v-autocomplete>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                               v-if="isTitle">
                            <v-autocomplete :items="title"
                                            :label="$t('parentHeaderLevel')"
                                            v-model="header.title" dense outlined
                                            item-value="id"
                                            item-text="value"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6"
                               md="4">
                            <v-checkbox :label="$t('isQuantityAmount')"
                                        v-model="header.isQuantityAmount"></v-checkbox>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                               v-if="isSubTitle">
                            <v-autocomplete :items="subtitle" dense outlined
                                            :label="$t('parentSubHeaderLevel')"
                                            v-model="header.subtitle"
                                            item-value="id"
                                            item-text="value"></v-autocomplete>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4">
                            <v-select :items="years"
                                      :label="$t('showyear')" dense outlined
                                      v-model="header.showYear"></v-select>
                        </v-col>

                        <v-col cols="12"
                               sm="6"
                               md="4" v-if="isSubTitle">
                            <v-autocomplete :items="typeList"
                                            :label="$t('type')" dense outlined
                                            v-model="header.dataType"
                                            item-value="value"
                                            item-text="id"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6"
                               md="4" v-if="report.enableSamikshyaReport">
                            <v-checkbox label="Show only on Samikshya Report"
                                        v-model="header.showOnlyOnSamikshyaReport"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6"
                               md="4" v-if="header.showOnlyOnSamikshyaReport==false && report.enableSamikshyaReport==true">
                            <v-checkbox label="Show on Samikshya Report"
                                        v-model="header.showOnSamikshyaReport"></v-checkbox>
                        </v-col>

                        <v-col cols="12"
                               sm="6"
                               md="4" v-if="header.type == 'RSTS' && report.enableSamikshyaReport==true">
                            <v-autocomplete :items="samikshyaGroup"
                                            label="Samikshya Calculation"
                                            v-model="header.groupSamikshya"
                                            item-value="value" dense outlined
                                            item-text="id"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6"
                               md="4" v-if="header.type == 'RSTS'">
                            <v-checkbox :label="$t('addToTotalColumn')"
                                        v-model="header.addToTotal"></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6"
                               md="4" v-if="header.type == 'RSTS'">
                            <v-checkbox :label="$t('totalColumn')"
                                        v-model="header.addTotal"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6"
                               md="4" v-if="header.type == 'RSTS'">
                            <v-checkbox :label="$t('isBudgetAmount')"
                                        v-model="header.isBudgetAmount"></v-checkbox>
                        </v-col>
                        <!--<v-col cols="12"
           sm="6"
           md="4"
              v-if="isSubSubTitle"
    >
        <v-checkbox

                label="Is total Header"
                v-model="header.isTotalHeader"
        ></v-checkbox>
    </v-col>-->
                        <!--                        <v-radio-group label="Year" v-model="header.year" :mandatory="false" row>-->
                        <!--                            -->
                        <!--                            <v-radio label="Previous" value="previous"></v-radio>-->
                        <!--                            <v-radio label="Current" value="current"></v-radio>-->
                        <!--                            <v-radio label="Next" value="next"></v-radio>-->
                        <!--                        </v-radio-group>-->
                    </v-row>
                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" @click="submit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import { mapGetters} from 'vuex'

    export default {
        name: "createHeaderForm",
        props: ["success"],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isTitle(){
                return this.header.type == "RST" || this.header.type == "RSTS"
            },
            isSubTitle(){
                return this.header.type == "RSTS"
            },
            isSubSubTitle(){
                return this.header.type == "RSTS"
            }
        },
        data() {
            return {
                years: ["","ThreeYear","TwoYear","Previous","Current","Next"],
                created: false,
                reportID:parseInt(this.$route.params.id),
                types:[],
                title:[],
                subtitle:[],
                companyList: [],
                header: { dataType: 2,showOnlyOnSamikshyaReport:false },
                typeList: [{ "id": "Text", "value": 1 }, { "id": "Amount", "value": 2 }, { "id": "Title", "value": 3 }, { "id": "Quantity", "value": 4 }, { "id": "Quantity1", "value": 6 },{"id":"Total","value":5}],
                snackbar: {
                    dateMenu: false,
                    servicesData:{
                        data:{},
                        message:"",
                        color:""
                    },
                },
                samikshyaGroup: [
                    { "id": "", "value": null },
                    { "id": "Group 1", "value": 1 },
                    { "id": "Group 2", "value": 2 },
                    { "id": "Group 1 Total", "value": 3 },
                    { "id": "Group 2 Total", "value": 4 }
                ],
                report: {}
            };
        },
        mounted() {
            this.formData()
                axios.get('ReportSettings/DDLReportHeadersSubTitleList',{params:{
                        ReportID:this.reportID
                    }}).then(response=>{
                        this.subtitle = response.data.headerList;
                        this.report = response.data.report;
                    })

        },
        methods: {
        dialogueClose() {
            this.departmentData = {};
            this.$emit("dialogueClose");
        },
        formResponse() {
            this.$emit("formResponse", this.snackbar.servicesData);
            this.dialogueClose();
        },
        async formData(){
            axios.get('ReportSettings/GetReportHeadersType').then(response=>{
                this.types = response.data
            })
        },
            changeDDL(){
                if(this.header.type == "RST" || this.header.type == "RSTS"){
                    this.changeTitle()
                }
                if (this.header.type == "RSTS") {
                    this.header.isBudgetAmount = false;
                }
            },
            changeTitle(){
                axios.get('ReportSettings/DDLReportHeadersTitleList',{params:{
                        ReportID:this.reportID
                    }}).then(response=>{
                    this.title = response.data
                })
            },
            submit() {
            let submitData = {
                name: this.header.name,
                reportID:this.reportID,
                type:this.header.type,
                titleID: parseInt(this.header.title),
                subTitleID: parseInt(this.header.subtitle),
                isTotalHeader: this.header.isTotalHeader,
                showYear: this.header.showYear,
                dataType: this.header.dataType,
                showOnSamikshyaReport: this.header.showOnSamikshyaReport,
                addToTotal: this.header.addToTotal,
                addTotal: this.header.addTotal,
                showOnlyOnSamikshyaReport: this.header.showOnlyOnSamikshyaReport,
                groupSamikshya: this.header.groupSamikshya,
                isQuantityAmount: this.header.isQuantityAmount,
                isBudgetAmount: this.header.isBudgetAmount,
            }
                axios.post("ReportSettings/ReportHeadersInsertAsync", submitData).then(response => {
                    if (response.data.success) {
                        this.snackbar.servicesData.data=response.data
                        this.snackbar.servicesData.message="Header added Successfully"
                        this.snackbar.servicesData.color="success"
                        this.formResponse()
                    }
                }).catch(response=>{
                    this.snackbar.servicesData.data=response.data
                    this.snackbar.servicesData.message="Error Adding Department, Please Contact Admin"
                    this.snackbar.servicesData.color="error"
                });
        },
        clear() {
            this.$v.$reset();
            this.departmentData = {};
            }
    }
    };
</script>

<style scoped>
</style>
